import { matchPath } from 'react-router-dom';

export const getMatchedPathFromBatch = (batch, path) => {
  const pathArray = Object.keys(batch).sort((a, b) => {
    const aDynamic = (a.match(/:\w+/g) || []).length;
    const bDynamic = (b.match(/:\w+/g) || []).length;

    if (aDynamic !== bDynamic) {
      return aDynamic - bDynamic; // template with fewer dynamic parts (:id) has higher priority
    }

    const aStatic = (a.match(/\/[^:]+/g) || []).length;
    const bStatic = (b.match(/\/[^:]+/g) || []).length;

    if (aStatic !== bStatic) {
      return bStatic - aStatic; // template with more static parts (/sports, /event ..) has higher priority
    }

    return b.length - a.length;
  });

  const matchedPath = pathArray.reduce((acc, i) => {
    if (acc) {
      return acc;
    }

    return matchPath(
      {
        path: i,
        end: true
      },
      path === '' ? '/' : path
    );
  }, null);

  return matchedPath?.pattern.path;
};
